import find from 'lodash/find'
import { FieldOption } from './accountTypes'

const groupUserRoles: FieldOption[] = [
  { name: 'Coach', value: 'coach' },
  { name: 'Head Coach', value: 'head_coach' },
  { name: '', value: null }
]

export default groupUserRoles

export function roleName (value: string | null): string | null {
  const option = find(groupUserRoles, { value })
  return option ? option.name : null
}
